import React, { useEffect, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers";
import { format, parse } from "date-fns";

const ApiDatePicker = ({ setSelectedDays }: any) => {
  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);

  const [startDate, setStartDate] = useState<Date | undefined>(oneMonthAgo);
  const [endDate, setEndDate] = useState<Date | undefined>(today);

  useEffect(() => {
    setSelectedDays({
      startDate: startDate
        ? new Date(startDate).toLocaleDateString("en-CA") // Formats as YYYY-MM-DD
        : null,
      endDate: endDate
        ? new Date(endDate).toLocaleDateString("en-CA") // Formats as YYYY-MM-DD
        : null,
    });
  }, [startDate, endDate]);

  const handleStartDateChange = (date: Date | null) => {
    if (date) {
      setStartDate(date);
      if (date > endDate!) {
        setEndDate(date); 
      }
    }
  };

  const handleEndDateChange = (date: Date | null) => {
    if (date) {
      setEndDate(date);
      if (date < startDate!) {
        setStartDate(date); // Automatically adjust the start date if it's after the end date
      }
    }
  };
 
  const formatDisplayDate = (date: Date | null) =>
  date ? format(date, "dd-MMM-yyyy") : ""; // Display formatted date
 
  const parseDisplayDate = (dateString: string) =>
  parse(dateString, "dd-MMM-yyyy", new Date()); 

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div style={{ display: "flex", alignItems: "center",gap: "10px",padding: "5px"}}>
      <DatePicker
          value={startDate }
          onChange={handleStartDateChange}
          maxDate={endDate}
          slotProps={{
            textField: {
              inputProps: {
                value: formatDisplayDate(startDate || null), // Format for display
                onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
                  setStartDate(parseDisplayDate(e.target.value)), // Parse back to Date
              },
              style: {
                width: "150px",
              },
            },
          }}
        
        />
        <span>to</span>
        <DatePicker
          value={endDate}
          onChange={handleEndDateChange}
          minDate={startDate}
          maxDate={today}
          slotProps={{
            textField: {
              inputProps: {
                value: formatDisplayDate(endDate || null), // Format for display
                onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
                  setEndDate(parseDisplayDate(e.target.value)), // Parse back to Date
              },
              style: {
                width: "150px",
              },
            },
          }}
        />
      </div>
        
      
    </LocalizationProvider>
  );
}


export default ApiDatePicker;
